// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'core-js/es6/array'
import 'core-js/es6/function'
import 'core-js/es6/map'
import 'core-js/es6/math'
import 'core-js/es6/number'
import 'core-js/es6/object'
import 'core-js/es6/promise'
import 'core-js/es6/regexp'
import 'core-js/es6/string'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/find'

import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import { isProduction, getQuery, getHash, bus, getPlatform } from "./common"
import App from './App'

// window.onerror = (message) => {
//   new Image().src = `/error/${message}`
// }

export default function({ loadingPath, router }){
  Vue.use(VueLazyload, {
    loading: loadingPath
  })
  Vue.config.productionTip = false

  // register for native webview event acceptor
  window.handleNativeNotify = (event) => {
    bus.$emit(event.name, event)
    // new Image().src = '/notify/'+event.name + '/' + JSON.stringify(event)
  }

  if(getPlatform() !== 'ios'){
    document.body.classList.add('android')
  }

  /* eslint-disable no-new */
  window.app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    mounted(){
      Vue.nextTick(() => {
        router.options.routes.map(route => {
          if(typeof route.component === 'function'){
            route.component(() => {}) // requires an empty function
          }
        })
      })
    }
  })

  const jump = getQuery('jump') || getHash('jump')
  if(jump && jump.startsWith('/')){
    router.push(jump)
  }

  /* if(!isProduction()) {
    import('vconsole').then(VConsole => {
      new VConsole()
    })
  } */

  // alert(location.href)
}







// WEBPACK FOOTER //
// ./src/main.js